import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    var params = utils.merge(example, pageable);

    return httpService.get("vbStepInfo", { params: params });
  },

  // check xem userDeptRole có thể sơ duyệt văn bản hay không
  isEnableSoDuyetForUser() {
    return httpService.get("vbStepInfo/getIsEnableSoDuyetOrNot");
  },

  // check xem userDeptRole có thể phê duyệt văn bản hay không
  isEnablePheDuyetForUser() {
    return httpService.get("vbStepInfo/getIsEnablePheDuyetOrNot")
  }
};



// WEBPACK FOOTER //
// ./src/services/vbStepInfoService.js